module.exports = __webpack_public_path__ + "static/media/TN-Women-DressShoes-2.0.6375b7ef.svg";